import { render, staticRenderFns } from "./ArticleJobsForm.vue?vue&type=template&id=3a4c8da4&"
import script from "./ArticleJobsForm.vue?vue&type=script&lang=js&"
export * from "./ArticleJobsForm.vue?vue&type=script&lang=js&"
import style0 from "./ArticleJobsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ArticleJobsForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports